<ngx-loading-bar></ngx-loading-bar>

<div class="example-container" [class.example-is-mobile]="mobileQuery.matches">
  <mat-sidenav-container
    class="example-sidenav-container"
    [style.marginTop.px]="mobileQuery.matches ? 0 : 0"
  >
    <!-- SideMenu Content Starts Here -->

    <mat-sidenav
      [opened]="screenWidth >= 800"
      #snav
      [mode]="mobileQuery.matches ? 'over' : 'side'"
      [fixedInViewport]="mobileQuery.matches"
      fixedTopGap="0"
    >
      <button
        [style.display]="screenWidth >= 800 ? 'none' : 'block'"
        mat-icon-button
        (click)="snav.toggle()"
      >
        <mat-icon>close</mat-icon>
      </button>
      <perfect-scrollbar>
        <school-aside
          (menuEvent)="receiveMenutitle($event)"
          style="overflow-x: hidden"
        ></school-aside>
      </perfect-scrollbar>
    </mat-sidenav>
    <!-- SideMenu Content Ends Here -->

    <mat-sidenav-content>
      <!-- Header Content Starts Here -->
      <mat-toolbar
        [style.width]="screenWidth >= 800 ? 'calc(100% - 300px)' : '100%'"
        color="primary"
        class="header fixedheader example-toolbar"
      >
        <button
          [style.display]="screenWidth >= 800 ? 'none' : 'block'"
          mat-icon-button
          (click)="snav.toggle()"
        >
          <mat-icon>menu</mat-icon>
        </button>
        <school-header [headingvalue]="headtext"></school-header>
        <span class="example-spacer"></span>
      </mat-toolbar>

      <!-- Header Content Ends Here -->

      <!-- Main Content Starts Here -->
      <ng-container>
        <div class="">
          <!-- <h1>Main Content</h1> -->
          <router-outlet></router-outlet>
        </div>
      </ng-container>
      <!-- Main Content Ends Here -->
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<!-- Copyright 2018 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license -->
